// src/pages/MedicalRecord/medicalRecordTourConfig.js

export const medicalRecordTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue dans Vos Dossiers Médicaux',
            description: 'Je vais vous guider à travers la gestion de vos dossiers médicaux et documents de santé.',
            side: 'over',
        },
    },
    {
        element: '.mr-content',
        popover: {
            title: '📋 Centre de Gestion des Dossiers',
            description: 'Cette page vous permet de gérer tous vos documents médicaux, résultats de tests et historique médical en un seul endroit.',
            position: 'center',
        },
    },
    {
        element: '.mr-col--left',
        popover: {
            title: '📁 Colonne Gauche - Actions et Documents Récents',
            description: 'Ici, vous pouvez télécharger de nouveaux documents et consulter vos documents récents des 3 derniers mois.',
            position: 'right',
        },
    },
    {
        element: '.mr-card--upload',
        popover: {
            title: '📤 Télécharger un Document Médical',
            description: 'Cliquez sur "Upload a Record" pour ajouter vos documents médicaux (résultats de tests, ordonnances, rapports médicaux, etc.).',
            position: 'bottom',
        },
    },
    {
        element: '.mr-card--upload button',
        popover: {
            title: '✅ Bouton de Téléchargement',
            description: 'Utilisez ce bouton pour lancer le processus de téléchargement de vos documents. Drag & drop ou cliquez pour sélectionner.',
            position: 'bottom',
        },
    },
    {
        element: '.mr-card--recent',
        popover: {
            title: '🕐 Documents Récents',
            description: 'Consultez vos documents des 3 derniers mois. Si votre médecin a demandé un test sanguin, vous verrez aussi une suggestion pour trouver un laboratoire.',
            position: 'bottom',
        },
    },
    {
        element: '.mr-card--recent button',
        popover: {
            title: '🏥 Trouver un Laboratoire',
            description: 'Cliquez ici pour trouver un laboratoire d\'analyses à proximité si votre médecin a prescrit des tests.',
            position: 'left',
        },
    },
    {
        element: '.mr-col--right',
        popover: {
            title: '📊 Colonne Droite - Historique Médical',
            description: 'Vue d\'ensemble complète de votre historique médical avec tous vos documents organisés par type.',
            position: 'left',
        },
    },
    {
        element: '.mr-card--history',
        popover: {
            title: '📈 Historique Médical Détaillé',
            description: 'Votre historique complet avec:',
            position: 'left',
        },
    },
    {
        element: '.mr-card--history',
        popover: {
            title: '🔍 Types de Documents',
            description: 'Les documents sont organisés par catégories: Bilan Biochimique, IRM, Échographie, Radiographie, Ordonnance, Compte Rendu, et Autres.',
            position: 'left',
        },
    },
    {
        element: '.mr-card--history',
        popover: {
            title: '📊 Statut du Stockage',
            description: 'Vous pouvez conserver jusqu\'à 10 fichiers. Le statut "Good" (Bon) indique que vous pouvez encore ajouter des documents.',
            position: 'left',
        },
    },
    {
        element: '.mr-alert-s',
        popover: {
            title: '⚠️ Message de Service',
            description: 'Si vous voyez cette alerte, cela signifie que le service d\'extraction de données des documents est temporairement indisponible. Réessayez plus tard.',
            position: 'bottom',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous savez maintenant comment gérer vos dossiers médicaux. N\'hésitez pas à télécharger vos documents et à consulter votre historique médical régulièrement.',
            side: 'over',
        },
    },
];
